// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"63":"745f57720d7131b7","411":"a56a7e99923e9a06","533":"f417c24dfd0602d1"}[chunkId] + ".js";
};